import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { Nav, Row, Tab } from "react-bootstrap";
import SVG from "react-inlinesvg";
import * as actions from "../../../_redux/school-reports/SchoolReportsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import "../../../../../../_metronic/_assets/sass/pages/wizard/wizard-4.scss";
import KTWizard from "../../../../../../_metronic/_assets/js/components/wizard";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { SchoolReportWizardNav } from "./SchoolReportWizardNav";
import { ReportDefinitionEditForm } from "./ReportDefinitionEditForm";
import { SchoolReportModulesPage } from "./shool-report-modules/SchoolReportModulesPage";
import { SchoolReportStudentsPage } from "./shool-report-students/SchoolReportStudentsPage";
import { SchoolReportSectionsPage } from "./shool-report-sections/SchoolReportSectionsPage";
import { ReportPrintingEditForm } from "./ReportPrintingEditForm";

export function SchoolReportEdit({
  history,
  match: {
    params: { id, step }
  }
}) {
  // Subheader
  const suhbeader = useSubheader();
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, schoolReport } = useSelector(
    (state) => ({
      actionsLoading: state.schoolReports.actionsLoading,
      isSuccess: state.schoolReports.isSuccess,
      type: state.schoolReports.type,
      schoolReport: state.schoolReports.schoolReport
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getSchoolReport(id));
    return () => dispatch(actions.cleanSchoolReportsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Okul Karnesi Düzenle";
    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // School Report Form Wizard
  const options = {
    startStep: step === "2" ? 2 : 1,
    clickableSteps: true
  };

  const wizard = new KTWizard(document.querySelector("#school_report_form_wizard"), options);

  /** Belli Bir Okul Karnesini Kaydeder */
  const saveSchoolReport = (values) => {
    dispatch(actions.saveSchoolReport(values)).then((result) => onResult(result));
  };

  /** Belli Bir Okul Karnesini Basıma Gönderir */
  const sendToPrint = (values) => {
    dispatch(actions.sendToPrint(values)).then((result) => onPrintResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => wizard.goNext(), 2500);
  };

  const onPrintResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/ogrenci-okul-karneleri"), 2500);
  };

  const btnRef = useRef();
  const saveSchoolReportClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const btnPrintRef = useRef();
  const sendToPrintClick = () => {
    if (btnPrintRef && btnPrintRef.current) {
      btnPrintRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    // <!--begin: Wizard -->
    <div
      className="wizard wizard-4"
      id="school_report_form_wizard"
      data-wizard-state="step-first"
    >
      <Card>
        <CardHeader title={title} />
        <CardBody>
          {/* <!--begin: Form Wizard Nav --> */}
          <SchoolReportWizardNav />
          {/* <!--end: Form Wizard Nav --> */}
        </CardBody>
      </Card>
            
      {/* <!--begin: Form Wizard Form--> */}
      {/* <!--begin: Form Wizard Step 1--> */}
      <div data-wizard-type="step-content" data-wizard-state="current">
        <Card>
          {actionsLoading && <ModalProgressBar />}
          <CardHeader title="Karne Tanımı">
            <CardHeaderToolbar>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={saveSchoolReportClick}
              >
                Kaydet ve İlerle
                <span className="svg-icon svg-icon-md ml-1">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-right.svg")} />
                </span>
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ReportDefinitionEditForm
              schoolReport={schoolReport}
              btnRef={btnRef} 
              saveSchoolReport={saveSchoolReport}
            />
          </CardBody>
        </Card>
      </div>
      {/* <!--end: Form Wizard Step 1--> */}

      {/* <!--begin: Form Wizard Step 2--> */}
      <div data-wizard-type="step-content">
        <SchoolReportModulesPage
          reportId={id}
          term={schoolReport.term}
          goNext={wizard.goNext}
        />
      </div>
      {/* <!--end: Form Wizard Step 2--> */}

      {/* <!--begin: Form Wizard Step 3--> */}
      <div data-wizard-type="step-content">
        <Tab.Container id="receipent-tabs" defaultActiveKey="students">
          <Card>
            <CardHeader>
              <CardHeaderToolbar>              
                <Row>
                  <Nav variant="pills" className="ml-5">
                    <Nav.Item>
                      <Nav.Link eventKey="students">Öğrenciler</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="sections">Sınıflar</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Row>
              </CardHeaderToolbar>
            </CardHeader>
          </Card>
          <Tab.Content>
            <Tab.Pane eventKey="students">
              <SchoolReportStudentsPage
                reportId={id}
                term={schoolReport.term}
                goNext={wizard.goNext}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="sections">
              <SchoolReportSectionsPage
                reportId={id}
                term={schoolReport.term}
                goNext={wizard.goNext}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      {/* <!--end: Form Wizard Step 3--> */}       

      {/* <!--begin: Form Wizard Step 4--> */}      
      <div data-wizard-type="step-content">
        <Card>
          {actionsLoading && <ModalProgressBar />}
          <CardHeader title="Karne Basımı">
            <CardHeaderToolbar>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={sendToPrintClick}
              >
                Kaydet ve Basıma Gönder
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ReportPrintingEditForm
              schoolReport={schoolReport}
              btnPrintRef={btnPrintRef} 
              sendToPrint={sendToPrint}
            />
          </CardBody>
        </Card>
      </div>
      {/* <!--end: Form Wizard Step 4--> */}
      {/* <!--end: Form Wizard Form--> */}
    </div>          
    // <!--end: Wizard -->
  );
}